module.exports = __webpack_public_path__ + "img/iran.e4181835.webp";